export const MaxTimeoutMs = 10000
